import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: String(process.env.REACT_APP_FIREBASE_API_KEY),
  authDomain: String(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
  projectId: String(process.env.REACT_APP_FIREBASE_PROJECT_ID),
  storageBucket: String(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: String(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID),
  appId: String(process.env.REACT_APP_FIREBASE_APPID),
  measurementId: String(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID),
};

const firebaseApp = initializeApp(firebaseConfig);

let messaging: any = null;

/**
 * Initializes Firebase Messaging ONLY if supported and in a valid environment.
 */
export const initMessaging = async () => {
  if (messaging) return messaging; // already initialized

  if (typeof window === 'undefined') {
    console.warn('Firebase Messaging skipped (SSR environment).');
    return null;
  }

  const supported = await isSupported().catch(() => false);

  if (!supported) {
    console.warn('Firebase Messaging is NOT supported in this browser/environment.');
    return null;
  }

  messaging = getMessaging(firebaseApp);
  console.log('🔥 Firebase Messaging enabled');
  return messaging;
};

/**
 * Requests FCM token safely.
 */
export const fetchToken = async () => {
  const msg = await initMessaging();
  if (!msg) return null;

  try {
    const currentToken = await getToken(msg, {
      vapidKey: process.env.REACT_APP_FIREBASE_KEYPAIR,
    });

    if (currentToken) {
      console.log('FCM Token:', currentToken);
      return currentToken;
    }

    console.warn('No registration token available. Permission may be needed.');
    return null;
  } catch (error) {
    console.error('Error retrieving FCM token:', error);
    return null;
  }
};

/**
 * Listener for foreground notifications.
 */
export const onMessageListener = async () => {
  const msg = await initMessaging();
  if (!msg) return null;

  return new Promise((resolve) => {
    onMessage(msg, (payload) => resolve(payload));
  });
};
